<div class="equipment-empty">
  <div class="no-data-content">
    <img src="./assets/img/equipment/equipment-empty.svg" alt="No equipment image" class="no-data-image">
    <h2 class="no-data-title">{{ 'equipment.empty.empty-title' | translate }}</h2>
    <p class="no-data-message">{{ 'equipment.empty.empty-message' | translate }}</p>
  </div>
</div>

